"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initPostTypes;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _utils = require("../common/utils");
var _getStatusManager = _interopRequireDefault(require("../common/getStatusManager"));
var _excluded = ["name", "addKeys", "keys"],
  _excluded2 = ["name", "addIfThereIsNot"];
function getDefaultPostTypesManager() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  function defaultAddPostType() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _p$name = p.name,
      name = _p$name === void 0 ? "post" : _p$name,
      addKeys = p.addKeys,
      keys = p.keys,
      rest = (0, _objectWithoutProperties2["default"])(p, _excluded);
    var statusManager = rest.statusManager || (0, _getStatusManager["default"])((0, _objectSpread2["default"])({
      wapp: wapp,
      name: name
    }, rest));
    var defaultPostTypeObject = Object.create(Object.prototype, {
      statusManager: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        value: statusManager
      }),
      subscribeUpdateFindById: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        value: function subscribeUpdateFindById() {
          var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _p$addKeys = p.addKeys,
            addKeys = _p$addKeys === void 0 ? [] : _p$addKeys,
            _p$keys = p.keys,
            keys = _p$keys === void 0 ? [name + "New", name + "Save", name + "Delete", name + "Approve", name + "Featured", name + "RemoveFeatured", name + "Ban"].concat((0, _toConsumableArray2["default"])(addKeys)) : _p$keys;
          if (wapp.states) {
            var statesHandleName = "subscribeUpdate" + name.slice(0, 1).toUpperCase() + name.slice(1) + "FindById";
            wapp.states.addHandle((0, _defineProperty2["default"])({}, statesHandleName, function (req, res, next) {
              var wappResponse = res.wappResponse;
              if (postTypesManager.postTypes[name].unsubscribeUpdateFindById) {
                postTypesManager.postTypes[name].unsubscribeUpdateFindById();
              }
              var unsubscribe = wappResponse.store.subscribe(function (_ref) {
                var type = _ref.type,
                  payload = _ref.payload;
                if (type === "INS_RES" && payload.name === "responses") {
                  var response = payload.value;
                  var foundEnabledKeys = false;
                  var findByIdBeforeUpdate = wappResponse.store.getState("res.responses." + name + "FindById");
                  if (findByIdBeforeUpdate !== null && findByIdBeforeUpdate !== void 0 && findByIdBeforeUpdate._id) {
                    keys.forEach(function (requestName) {
                      if (!foundEnabledKeys && response && response[requestName]) {
                        foundEnabledKeys = true;
                        if (typeof response[requestName].record !== "undefined" && !response[requestName].error) {
                          var _response$requestName;
                          var newId = (_response$requestName = response[requestName].record) === null || _response$requestName === void 0 ? void 0 : _response$requestName._id;
                          if (newId === findByIdBeforeUpdate._id) {
                            wappResponse.store.dispatch(wapp.states.stateManager.actions.res({
                              type: "INS_RES",
                              name: "responses",
                              value: (0, _defineProperty2["default"])({}, name + "FindById", response[requestName].record)
                            }));
                          }
                        }
                      }
                    });
                  }
                }
              });
              postTypesManager.postTypes[name].unsubscribeUpdateFindById = function () {
                unsubscribe();
                postTypesManager.postTypes[name].unsubscribeUpdateFindById = null;
              };
              next();
            }));
          }
        }
      }),
      unsubscribeUpdateFindById: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        value: null
      })
    });
    Object.defineProperty(postTypesManager.postTypes, name, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultPostTypeObject
    }));
    postTypesManager.postTypes[name].subscribeUpdateFindById({
      addKeys: addKeys,
      keys: keys
    });
    return postTypesManager.postTypes[name];
  }
  function defaultGetPostType(_ref2) {
    var name = _ref2.name,
      addIfThereIsNot = _ref2.addIfThereIsNot,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
    var postType = postTypesManager.postTypes[name];
    if (postType || !addIfThereIsNot) {
      return postType;
    }
    return postTypesManager.addPostType((0, _objectSpread2["default"])({
      name: name
    }, rest));
  }
  function defaultFindPostType(_ref3) {
    var name = _ref3.name;
    return postTypesManager.postTypes[name];
  }
  var postTypesManager = Object.create(Object.prototype, {
    addPostType: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAddPostType
    }),
    getPostType: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultGetPostType
    }),
    findPostType: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultFindPostType
    }),
    postTypes: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: {}
    })
  });
  return postTypesManager;
}
function initPostTypes() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  var client = wapp.client;
  if (!client.postTypes) {
    var _p$postTypesManager = p.postTypesManager,
      postTypesManager = _p$postTypesManager === void 0 ? getDefaultPostTypesManager(p) : _p$postTypesManager;
    Object.defineProperty(client, "postTypes", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: postTypesManager
    }));
    Object.defineProperty(client.postTypes, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }));
  }
  return client.postTypes;
}